import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function CountrySelect({ value, onChange, usuarioRelleno }) {
  const { t, i18n } = useTranslation();

  const initialOptions = [
    { value: "ESP", label: 'españa' },
    { value: "USA", label: 'estados unidos' },
    { value: "FRA", label: 'francia' },
    { value: "DEU", label: 'alemania' },
    { value: "ITA", label: 'italia' },
    { value: "GBR", label: 'reino unido' },
    { value: "CAN", label: 'canadá' },
    { value: "AUS", label: 'australia' },
    { value: "BRA", label: 'brasil' },
    { value: "ARG", label: 'argentina' },
    { value: "MEX", label: 'méxico' },
    { value: "CHN", label: 'china' },
    { value: "IND", label: 'india' },
    { value: "JPN", label: 'japón' },
    { value: "RUS", label: 'rusia' },
    { value: "ZAF", label: 'sudáfrica' },
    { value: "EGY", label: 'egipto' },
    { value: "KOR", label: 'corea del sur' },
    { value: "TUR", label: 'turquía' },
    { value: "SAU", label: 'arabia saudí' },
    { value: "SWE", label: 'suecia' },
    { value: "NOR", label: 'noruega' },
    { value: "CHE", label: 'suiza' },
    { value: "NLD", label: 'países bajos' },
    { value: "BEL", label: 'bélgica' },
    { value: "AUT", label: 'austria' },
    { value: "DNK", label: 'dinamarca' },
    { value: "FIN", label: 'finlandia' },
    { value: "POL", label: 'polonia' },
    { value: "CZE", label: 'república checa' },
    { value: "HUN", label: 'hungría' },
    { value: "GRC", label: 'grecia' },
    { value: "PRT", label: 'portugal' },
    { value: "IRL", label: 'irlanda' },
    { value: "NZL", label: 'nueva zelanda' },
    { value: "SGP", label: 'singapur' }
  ];

  const [options, setOptions] = useState([]);

  useEffect(() => {
    const sortedOptions = initialOptions.map(option => ({
      value: option.value,
      label: t(option.label)
    })).sort((a, b) => a.label.localeCompare(b.label, i18n.language));

    setOptions(sortedOptions);
  }, [t, i18n.language]);

  const handleSelectChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };


if(usuarioRelleno == null){
  return (
    <select
      className="cewy-input"
      id="countrySelector"
      onChange={handleSelectChange}
      value={value} 
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}else{
  return (
    <select
      className="cewy-input"
      id="countrySelector"
      onChange={handleSelectChange}
      value={value} disabled
    >
      {options.map(option => (
        <option key={option.value} value={option.value}
        selected = {option.value == value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
 
}

export default CountrySelect;
